import React from 'react';
import {
    Slide,
} from '@mui/material'

export const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const isSameItemExact = (a, bItem, modifiers = []) => {
  const sameId = a._id.toString() === bItem._id.toString();
  const existingModifiers = a.modifiers || [];

  if (modifiers.length === 0) return sameId;

  const normalize = (mods) =>
    mods
      .map(mod => `${mod.name}:${mod.price}`)
      .sort()
      .join('|');

  const aMods = normalize(existingModifiers);
  const bMods = normalize(modifiers);

  return sameId && aMods === bMods;
};

export const allModifiersSelected = (modifiers, selectedModifiers) => {
  return modifiers
    .filter(mod => mod.selectOne)
    .every(mod => {
      const selected = selectedModifiers[mod._id];
      return selected && typeof selected.name === 'string' && selected.name !== '';
    });
};

export const flattenModifiers = (selectedModifiers) => {
    const result = [];

    Object.values(selectedModifiers).forEach(value => {
        if (Array.isArray(value)) {
            // multi-select group
            value.forEach(item => result.push({ name: item.name, price: item.price }));
        }
        else if (value && typeof value === 'object') {
            // single-select group
            result.push({ name: value.name, price: value.price });
        }
    });

    return result;
};


export const calculateRoundedTax = (order, taxRate, isReduced) => {
    return order.reduce((sum, item) => {
      const applies = isReduced ? item.reducedTax : !item.reducedTax;
      if (!applies) return sum;
      
      const taxAmount = item.total * (taxRate / 100);
      return sum + Math.ceil(taxAmount * 100) / 100;
    }, 0);
}

export const CalculateRoundedTip = (subtotal, percent) => {
    return Math.ceil(subtotal * percent * 100) / 100;
}

export const formatPhoneNumber = (value) => {
    if (typeof value !== 'string' || value.length === 0) return

    const phoneNumber = value.replace(/\D/g, ''); // Remove non-digit characters
    const phoneLength = phoneNumber.length;

    if (phoneLength < 4) {
        return phoneNumber;
    }
    else if (phoneLength < 7) {
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    else {
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
    }
};

export const formatCurrency = (value) => {
    const num = parseFloat(value.replace(/[^\d.-]/g, ''));
    if (isNaN(num)) {
        return '';
    }
    else {
        return num.toLocaleString('en-US',
        {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }
}

export const formatNumber = (value) => {
    const raw = value.replace(/[^\d.-]/g, '');
    const num = parseFloat(raw);
    if (isNaN(num)) {
        return '';
    }
    const integer = Math.trunc(num);
    return integer.toLocaleString('en-US');
};
